import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { Chart } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

Chart.register(annotationPlugin);

createApp(App).use(router).mount('#app');
